import { axiosInstance } from '../clients/axiosClient';
import { API_V1_PREFIX, QUOTES_API_PREFIX } from '../utils/constants';

export interface Quote {
    id: number;
    quote: string;
    plans: string[];
    created_at?: string;
    updated_at?: string;
}

export const getQuotesList = async (limit: number = 10, offset: number = 0): Promise<{ quotesList: Quote[]; total_count: number }> => {
    try {
        const { data } = await axiosInstance.get(`${API_V1_PREFIX}${QUOTES_API_PREFIX}list`, {
            params: { limit, offset }
        });
        return {
            quotesList: data.quotes || [],
            total_count: data.total_count || 0
        };
    } catch (error: any) {
        throw new Error(error?.message || 'Failed to fetch quotes');
    }
};

export const createQuote = async (
    newQuote: Omit<Quote, 'id' | 'created_at' | 'updated_at'>
): Promise<{ id: number; status: string }> => {
    try {
        const { data } = await axiosInstance.post(
            `${API_V1_PREFIX}${QUOTES_API_PREFIX}`,
            newQuote
        );
        return data;
    } catch (error: any) {
        if (error.response?.data?.description) {
            throw new Error(error.response.data.description);
        }
        throw new Error(error?.message || 'Failed to create quote');
    }
};

export const getQuoteById = async (quoteId: number): Promise<Quote> => {
    try {
        const { data } = await axiosInstance.get(`${API_V1_PREFIX}${QUOTES_API_PREFIX}${quoteId}`);
        return data;
    } catch (error: any) {
        throw new Error(error?.message || 'Failed to fetch quote');
    }
};

export const updateQuote = async (
    updatedQuote: Pick<Quote, 'id' | 'quote' | 'plans'>
): Promise<{ id: number; status: string }> => {
    try {
        const { data } = await axiosInstance.patch(
            `${API_V1_PREFIX}${QUOTES_API_PREFIX}`,
            updatedQuote
        );
        return data;
    } catch (error: any) {
        if (error.response?.data?.description) {
            throw new Error(error.response.data.description);
        }
        throw new Error(error?.message || 'Failed to update quote');
    }
};

export const deleteQuote = async (quoteId: number): Promise<void> => {
    try {
        await axiosInstance.delete(
            `${API_V1_PREFIX}${QUOTES_API_PREFIX}`,
            { data: { id: quoteId } }
        );
    } catch (error: any) {
        if (error.response?.data?.description) {
            throw new Error(error.response.data.description);
        }
        throw new Error(error?.message || 'Failed to delete quote');
    }
};
